<template src="./template.html" />
<script>
/* eslint-disable */
import DetailPage from 'src/modules/pages/detail-page'
import { mapGetters } from 'vuex'
const axios = require('axios')
import schemas from './schemas.js'
import FireStoreParser from 'firestore-parser'
import TimestampUtils from 'utils/TimestampUtils'
export default {
  name: 'OrderDetail',
  components: {
    'DetailPage': DetailPage
  },
  props: {'orderId': {
    type: String,
    default: ''
  }, 'mode':{
    type: String,
    default: ''
  }, 'data':{
    type: Object,
    default: () => {}
  }},
  data () {
    return {
      scaffolding: {
        'items': {
          'item-1': {
            type: 'Collumns',
            fieldName: '{this.root}',
            leftRightMode: true,
            css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''}`],
            colBody: [
              {
                'item-1': {
                  label: 'Phòng ban',
                  type: 'Select',
                  validation: 'required',
                  fieldName: 'department',
                  datasource: {
                    options: [],
                    label: 'name',
                    value: 'id'
                  },
                  default: {
                    id: 'TB',
                    name: 'Truyền thống'
                  },
                  readonly: true,
                  icon: 'store',
                },
                'item-2': {
                  label: 'Mã hợp đồng',
                  type: 'TextField',
                  fieldName: 'noContract',
                  icon: 'business',
                  readonly: true,
                },
                'item-3': {
                  type: 'TextField',
                  label: 'Cập nhật lần cuối bởi',
                  icon: 'speaker_notes',
                  fieldName: 'lastModifiedBy',
                  readonly: true,
                },
                'item-4': {
                  label: 'Khách hàng',
                  type: 'Select',
                  validation: 'required',
                  fieldName: 'customer',
                  useInput: true,
                  datasource: {
                    options: [],
                    label: 'name',
                    field: 'byName',
                    value: 'id'
                  },
                  icon: 'people',
                  readonly: true,
                },
                'item-5': {
                  label: 'Nơi giao hàng',
                  type: 'TextField',
                  validation: 'required',
                  fieldName: 'deliveryLocation',
                  icon: 'location_city',
                  readonly: true,
                },
                'item-6': {
                  label: 'Thời gian giao hàng',
                  type: 'DateRangePicker',
                  validation: 'required',
                  fieldName: '{this.root}',
                  startDateFieldName: 'deliveryStartTime',
                  endDateFieldName: 'deliveryEndTime',
                  readonly: true,
                },
                'item-7': {
                  label: 'Phương thức thanh toán',
                  type: 'Select',
                  fieldName: 'paymentMethod',
                  icon: 'payment',
                  validation: 'required',
                  useInput: true,
                  datasource: {
                    options: [],
                    field: 'list',
                    label: 'label',
                    value: 'value',
                    emitValue: true
                  },
                  readonly: true,
                  sortBy: 'label'
                }
              },
              {
                'item-1': {
                  label: 'Trạng thái đơn hàng',
                  type: 'Select',
                  validation: 'required',
                  fieldName: 'orderStatus',
                  useChip: true,
                  isLoading: true,
                  inputKey: 1,
                  datasource: {
                    options: [],
                    label: 'name',
                    value: 'id',
                    color: 'color'
                  },
                  icon: 'linear_scale',
                  readonly: true
                },
                'item-2': {
                  label: 'Nhân viên bán hàng',
                  type: 'Select',
                  validation: 'required',
                  fieldName: 'salesOwner',
                  icon: 'person',
                  datasource: {
                    options: [],
                    field: 'list',
                    label: 'displayName',
                    value: 'email',
                    avatar: 'photoURL'
                  },
                  sortBy: 'displayName',
                  readonly: true
                },
                'item-3': {
                  type: 'DatePicker',
                  label: 'Ngày cập nhật',
                  icon: 'speaker_notes',
                  fieldName: 'lastModifiedTime',
                  readonly: true,
                },
                'item-4': {
                  label: 'Mã đơn hàng',
                  type: 'SlashTextField',
                  fieldName: '{this.root}',
                  primaryName: 'primaryOrderCode',
                  subName: 'subOrderCode',
                  icon: 'receipt',
                  readonly: true
                },
                'item-5': {
                  label: 'Điều kiện giao hàng',
                  type: 'Select',
                  fieldName: 'deliveryCondition',
                  icon: 'local_shipping',
                  validation: 'required',
                  useInput: true,
                  datasource: {
                    options: [],
                    field: 'list',
                    label: 'label',
                    value: 'value',
                    emitValue: true
                  },
                  sortBy: 'label',
                  readonly: true
                },
                'item-6': {
                  type: 'Collumns',
                  fieldName: '{this.root}',
                  css: [`col-12 col-md-6 ${this.$q.screen.xs ? '' : 'q-pl-xs'}`, `col-12 col-md-6 ${this.$q.screen.xs ? '' : 'q-pl-xs'}`],
                  colBody: [
                    {
                      'item-1': {
                        type: 'Select',
                        label: 'Nhà cung cấp',
                        fieldName: 'supplier',
                        icon: 'fas fa-parachute-box',
                        useInput: true,
                        sortBy: 'name',
                        readonly: true,
                        datasource: {
                          path: 'MasterData/Supplier',
                          label: 'name',
                          value: 'id',
                          field: 'list'
                        }
                      }
                    },
                    {
                      'item-1': {
                        label: 'Kho',
                        type: 'TextField',
                        fieldName: 'wareHouse',
                        icon: 'home',
                        readonly: true
                      }
                    }
                  ]
                },
                'item-7': {
                  type: 'Collumns',
                  fieldName: '{this.root}',
                  css: [`col-12 col-md-3 ${this.$q.screen.xs ? '' : 'q-pl-xs'}`, `col-12 col-md-4 ${this.$q.screen.xs ? '' : 'q-pl-xs'}`, `col-12 col-md-5 ${this.$q.screen.xs ? '' : 'q-pl-xs'}`],
                  colBody: [
                    {
                      'item-1': {
                        type: 'Label',
                        label: 'Tổng tiền',
                        fieldName: 'totalMoney',
                        readonly: true,
                        notifyUpdateModelprops: 'totalMoneyitem-2',
                        class: 'text-subtitle1',
                        newLine: true
                      },
                      'item-2': {
                        'fieldName': 'totalMoney',
                        'type': 'ComputedField',
                        'label': 'Tổng tiền',
                        'func': 'this.rootModel && this.rootModel && this.rootModel.productList ? this.math.sum(this.rootModel.productList.map(x => x.money)) : \'\'',
                        'afterCompute': 'this.parent.$refs[\'0\' + this.parent._uid + \'totalMoneyitem-1\'][0].value = this.NumberUtils.thousandSeprator(this.value)',
                        'watch': true
                      }
                    },
                    {
                      'item-1': {
                        label: 'Tiền tệ',
                        type: 'Select',
                        validation: 'required',
                        fieldName: 'unitMoney',
                        datasource: {
                          options: [],
                          label: 'label',
                          value: 'value',
                          emitValue: true,
                          field: 'list'
                        },
                        sortBy: 'label',
                        readonly: true
                      }
                    },
                    {
                      'item-1': {
                        label: 'Tỷ giá',
                        type: 'NumberField',
                        fieldName: 'exchangeRate',
                        readonly: true,
                        validation: 'required|min_value:0|excluded:0',
                        format: '0,0.[0000]'
                      }
                    }
                  ]
                }
              }
            ]
          },
          'item-1.1': {
            'label': 'Điều khoản thanh toán',
            'indexColumn': true,
            'dataType': 'SingleArray',
            'editable': false,
            'canDelete': true,
            'inputKey': 1,
            'type': 'DataTable',
            'hideBottom': true,
            'pagination': {
              'rowsPerPage': 0,
              'descending': true
            },
            'fieldName': 'paymentPolicyList',
            'addType': 'last',
            'flat': true,
            bordered: true,
            'columns': [
              {
                'label': 'Số tiền',
                'field': 'amount',
                'fieldName': 'amount',
                'syncModel': true,
                'name': 'name',
                'align': 'left',
                'type': 'NumberField',
                validation: 'min_value:0|max_value:@@{this.rootModel.totalMoney ? this.rootModel.totalMoney : 0}',
                readonly: true,
                onBlur: `this.parent.$refs[this.parent._uid + 'percentitem-2'][0].$emit('onInput', this.rootModel.totalMoney && this.rootModel.totalMoney !== 0 ? parseFloat(this.value / this.rootModel.totalMoney) * 100 : 0)`,
                watch: true
              },
              {
                'field': 'percent',
                'name': 'percent',
                'type': 'NumberField',
                'align': 'center',
                'label': 'Phần trăm',
                '@tableOnly': {
                  'showFormat': `props.row.percent + '%'`
                },
                validation: 'min_value:0|max_value:100',
                readonly: true,
                onBlur: `this.parent.$refs[this.parent._uid + 'amountitem-1'][0].$emit('onInput', this.rootModel.totalMoney && this.rootModel.totalMoney !== 0 ? ((this.value / 100) * this.rootModel.totalMoney) : 0)`,
                watch: true
              },
              {
                'field': 'days',
                'name': 'days',
                'type': 'NumberField',
                'align': 'center',
                'label': 'Số ngày',
                validation: 'required',
                readonly: true
              },
              {
                type: 'Select',
                fieldName: 'dateType',
                field: 'dateType',
                name: 'dateType',
                label: 'Ngày',
                validation: 'required',
                '@tableOnly': {
                  showFormat: `props.row.dateType ? props.row.dateType.label : ''`
                },
                datasource: {
                  options: [],
                  label: 'label',
                  value: 'value',
                  field: 'list'
                },
                sortBy: 'label',
                readonly: true
              }
            ]
          },
          'item-2': {
            label: 'Ghi chú',
            type: 'TextArea',
            fieldName: 'orderNote',
            icon: 'speaker_notes',
            readonly: true,
            class: !this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''
          },
          'item-3': {
            type: 'Collapse',
            label: 'Sản phẩm theo PO',
            icon: 'fas fa-lemon',
            fieldName: '{this.root}',
            centerText: {
              value: 'this.modelProps.hasOwnProperty(\'mfgGeneralStatus\') ? this.modelProps.mfgGeneralStatus.name : \'\'',
              useChip: true,
              color: 'this.modelProps.hasOwnProperty(\'mfgGeneralStatus\') ? this.modelProps.mfgGeneralStatus.color : \'\''
            },
            defaultOpened: true,
            items: {
              'item-0': {
                type: 'Select',
                label: 'Tình trạng sản xuất chung',
                fieldName: 'mfgGeneralStatus',
                class: 'q-pl-md q-pr-md',
                inputKey: 1,
                icon: 'assignment_turned_in',
                datasource: {
                  options: [],
                  label: 'name',
                  value: 'id'
                },
                show: false
              },
              'item-1': {
                type: 'Collumns',
                fieldName: '{this.root}',
                css: [`col-12 col-md-4 ${this.$q.screen.xs ? '' : 'q-pl-xs'}`],
                colBody: [
                  {
                    'item-1': {
                      type: 'DatePicker',
                      fieldName: 'mfgExpectedDate',
                      label: 'Ngày giao hàng',
                      readonly: true,
                      css: 'q-pl-md q-pr-md'
                    }
                  }
                ]
              },
              'item-2': {
                'indexColumn': true,
                'dataType': 'SingleArray',
                'editable': false,
                'canDelete': true,
                'inputKey': 1,
                'type': 'DataTable',
                bordered: true,
                'hideBottom': true,
                'pagination': {
                  'rowsPerPage': 0,
                  'descending': true
                },
                'fieldName': 'productList',
                'addType': 'last',
                'flat': true,
                'columns': [
                  {
                    'label': 'Sản phẩm',
                    'field': 'name',
                    'fieldName': '{this.root}',
                    '@tableOnly': {
                      'showFormat': 'props.row.name.concat(props.row.detail || props.row.hasOwnProperty(\'detail\') ? \' (\' + props.row.detail + \')\' : \'\')'
                    },
                    'syncModel': true,
                    'name': 'name',
                    'align': 'left',
                    'type': 'Select',
                    'isMerge': true,
                    'useInput': true,
                    'validation': {
                      'required': true
                    },
                    subribers: [[`vm.parent._uid + 'notDefineditem-4'`], [`vm.parent._uid + '{this.root}item-8'`, `'2' + vm.parent.$refs[vm.parent._uid + '{this.root}item-8'][0]._uid + 'notDefineditem-1'`]],
                    'datasource': {
                      options: [],
                      label: 'name',
                      value: 'id'
                    },
                    readonly: true
                  },
                  {
                    'field': 'detail',
                    'name': 'detail',
                    'type': 'TextArea',
                    'align': 'center',
                    'label': 'Chi tiểt',
                    'showInTable': false,
                    readonly: true
                  },
                  {
                    'field': 'unitPrice',
                    'name': 'unitPrice',
                    'type': 'NumberField',
                    'align': 'center',
                    'validation': 'required|decimal|min_value:0',
                    'label': 'Đơn giá',
                    readonly: true
                  },
                  {
                    'field': 'unit',
                    'name': 'unit',
                    'fieldName': 'notDefined',
                    'type': 'ComputedField',
                    'label': 'Đơn vị tính',
                    'align': 'center',
                    'func': '(this.rootModel.unitMoney ? this.rootModel.unitMoney : \'NA\') + \'/\' + (this.parent.value.unit ? this.parent.value.unit : \'NA\')',
                    'watch': true,
                    'show': true,
                    'showOnly': true,
                    '@tableOnly': {
                      'showFormat': '(this.rootModel.unitMoney ? this.rootModel.unitMoney : \'NA\') + \'/\' + (props.row.unit ? props.row.unit : \'NA\')'
                    }
                  },
                  {
                    'field': 'quantity',
                    'name': 'quantity',
                    'type': 'NumberField',
                    'align': 'center',
                    'validation': 'required|decimal|min_value:0',
                    'label': 'Số lượng',
                    readonly: true
                  },
                  {
                    // Show only in dialog
                    'field': 'moneyShow',
                    'name': 'moneyShow',
                    'fieldName': '{this.root}',
                    'type': 'Label',
                    'align': 'center',
                    'label': 'Thành tiền',
                    'format': '!isNaN(this.modelProps.unitPrice * this.modelProps.quantity) ? this.NumberUtils.thousandSeprator(this.modelProps.unitPrice * this.modelProps.quantity) : \'0\'',
                    'watch': true,
                    'showInTable': false
                  },
                  {
                    'field': 'money',
                    'name': 'money',
                    'fieldName': 'money',
                    'type': 'ComputedField',
                    'label': 'Thành tiền',
                    'align': 'center',
                    'func': '!isNaN(this.parent.value.unitPrice * this.parent.value.quantity) ? this.parent.value.unitPrice * this.parent.value.quantity : undefined',
                    'watch': true,
                    '@tableOnly': {
                      'showFormat': 'this.NumberUtils.thousandSeprator(props.row.money)'
                    }
                  },
                  {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    show: false,
                    css: [`col-12 col-sm-6 q-pr-xs`, `col-12 col-sm-5`, `col-1 col-sm-1 relative-position`],
                    colBody: []
                  },
                  {
                    'field': 'mfgStatus',
                    'name': 'mfgStatus',
                    'type': 'Select',
                    'label': 'Tình trạng sản xuất',
                    'align': 'center',
                    'datasource': {
                      options: [],
                      label: 'statusName',
                      value: 'id',
                      pickNext: true,
                      pickDefault: 'received'
                    },
                    '@tableOnly': {
                      'type': 'Label',
                      'config': {
                        'format': 'this.value.statusName',
                        'chipMode': true,
                        colorChip: 'this.value.color',
                        watch: true
                      }
                    },
                    readonly: true,
                    readonly: true
                  }
                ]
              },
              'item-3': {
                label: 'Ghi chú',
                type: 'TextArea',
                fieldName: 'productNote',
                icon: 'speaker_notes',
                readonly: true,
                class: !this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''
              }
            }
          },
          'item-4': {
            type: 'Collapse',
            label: 'Giao hàng',
            icon: 'local_shipping',
            fieldName: '{this.root}',
            centerText: {
              value: 'this.modelProps.hasOwnProperty(\'deliveryStatus\') ? this.modelProps.deliveryStatus.name : \'\'',
              useChip: true,
              color: 'this.modelProps.hasOwnProperty(\'deliveryStatus\') ? this.modelProps.deliveryStatus.color : \'\''
            },
            items: {
              'item-1': {
                type: 'Collumns',
                fieldName: '{this.root}',
                leftRightMode: true,
                css: [`col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pa-md' : ''}`, `col-12 col-md-6 ${!this.$q.screen.xs ? 'q-pa-md' : ''}`],
                colBody: [
                  {
                    'item-1': {
                      type: 'Select',
                      label: 'Hình thức vận chuyển',
                      icon: 'local_airport',
                      fieldName: 'transportType',
                      datasource: {
                        options: [{ label: 'Đường bộ', value: 'overland' }, { label: 'Hàng không', value: 'air' }, { label: 'Đường biển', value: 'sea' }],
                        label: 'label',
                        value: 'value'
                      },
                      readonly: true,
                      readonly: true
                    },
                    'item-2': {
                      label: 'Số hiệu vận tải',
                      type: 'TextField',
                      fieldName: 'transportShipName',
                      readonly: true,
                      icon: 'fas fa-ship',
                      readonly: true
                    },
                    'item-3': {
                      type: 'TextField',
                      label: 'Mã Booking',
                      fieldName: 'transportBookingCode',
                      icon: 'vpn_key',
                      readonly: true,
                      readonly: true
                    },
                    'item-4': {
                      type: 'DatePicker',
                      label: 'Ngày mở tờ khai',
                      fieldName: 'transportDeclarationFormDate',
                      readonly: true,
                      readonly: true
                    },
                    'item-5': {
                      type: 'Select',
                      label: 'POL',
                      fieldName: 'transportPOL',
                      icon: 'location_on',
                      useInput: true,
                      sortBy: 'name',
                      datasource: {
                        options: [],
                        field: 'list',
                        label: 'name',
                        value: 'id'
                      },
                      readonly: true,
                      readonly: true
                    },
                    'item-6': {
                      type: 'Select',
                      label: 'POD',
                      fieldName: 'transportPOD',
                      icon: 'location_on',
                      useInput: true,
                      datasource: {
                        options: [],
                        field: 'list',
                        label: 'name',
                        value: 'id'
                      },
                      readonly: true,
                      readonly: true
                    },
                    'item-7': {
                      type: 'DatePicker',
                      label: 'Ngày gửi chứng từ gốc',
                      fieldName: 'transportOriginalDocument',
                      readonly: true,
                      readonly: true
                    },
                    'item-8': {
                      label: 'Forwarder',
                      type: 'TextField',
                      fieldName: 'forwarder',
                      icon: 'fas fa-share',
                      readonly: true,
                      readonly: true
                    },
                    'item-9': {
                      label: 'Ngày xuất kho',
                      fieldName: 'exportWarehouseDate',
                      type: 'DatePicker',
                      readonly: true,
                      readonly: true
                    }
                  },
                  {
                    'item-1': {
                      type: 'Select',
                      label: 'Container',
                      icon: 'fas fa-box-open',
                      fieldName: 'transportContainer',
                      datasource: {
                        options: [{ label: 'LCL', value: 'lcl' }, { label: 'FCL20', value: 'fcl20' }, { label: 'FCL40', value: 'fcl40' }],
                        label: 'label',
                        value: 'value'
                      },
                      readonly: true,
                      readonly: true
                    },
                    'item-2': {
                      label: 'Số Cont',
                      type: 'TextField',
                      fieldName: 'containerNumber',
                      icon: 'fas fa-truck-moving',
                      readonly: true,
                      readonly: true
                    },
                    'item-3': {
                      type: 'Collumns',
                      fieldName: '{this.root}',
                      leftRightMode: true,
                      css: [`col-12 col-md-6`, `col-12 col-md-6 q-pl-md`],
                      colBody: [
                        {
                          'item-1': {
                            label: 'Mã vận đơn',
                            type: 'TextField',
                            fieldName: 'transportBillNo',
                            icon: 'fas fa-dolly',
                            readonly: true,
                            readonly: true
                          }
                        },
                        {
                          'item-1': {
                            label: 'Ngày vận đơn',
                            type: 'DatePicker',
                            fieldName: 'bodDate',
                            readonly: true,
                            readonly: true
                          }
                        }]
                    },
                    'item-4': {
                      type: 'DatePicker',
                      label: 'Ngày thông quan',
                      fieldName: 'transportClearanceDate',
                      readonly: true,
                      readonly: true
                    },
                    'item-5': {
                      type: 'DatePicker',
                      label: 'ETD',
                      fieldName: 'transportETD',
                      readonly: true,
                      readonly: true
                    },
                    'item-6': {
                      type: 'DatePicker',
                      label: 'ETA',
                      fieldName: 'transportETA',
                      readonly: true,
                      readonly: true
                    },
                    'item-7': {
                      type: 'DatePicker',
                      label: 'Ngày gửi scan chứng từ',
                      fieldName: 'transportScanDate',
                      readonly: true,
                      readonly: true
                    },
                    'item-8': {
                      label: 'Hoá đơn vận tải',
                      type: 'TextField',
                      fieldName: 'transportInvoice',
                      icon: 'receipt',
                      readonly: true,
                      readonly: true
                    },
                    'item-9': {
                      label: 'Phiếu xuất kho',
                      fieldName: 'billExportWarehouse',
                      type: 'TextField',
                      icon: 'receipt',
                      readonly: true,
                      readonly: true
                    }
                  }
                ]
              },
              'item-2': {
                'indexColumn': true,
                label: 'Sản phẩm theo khai hải quan',
                'dataType': 'SingleArray',
                'editable': false,
                'canDelete': false,
                'inputKey': 1,
                'type': 'DataTable',
                bordered: true,
                'hideBottom': true,
                'pagination': {
                  'rowsPerPage': 0,
                  'descending': true
                },
                'fieldName': 'productLogistics',
                'addType': 'last',
                'flat': true,
                'columns': [
                  {
                    'label': 'Sản phẩm',
                    'field': 'name',
                    'fieldName': '{this.root}',
                    '@tableOnly': {
                      'showFormat': 'props.row.name.concat(props.row.detail || props.row.hasOwnProperty(\'detail\') ? \' (\' + props.row.detail + \')\' : \'\')'
                    },
                    'syncModel': true,
                    'name': 'name',
                    'align': 'left',
                    'type': 'Select',
                    'isMerge': true,
                    'useInput': true,
                    'validation': {
                      'required': true
                    },
                    subribers: [[`vm.parent._uid + 'notDefineditem-4'`], [`vm.parent._uid + '{this.root}item-8'`, `'2' + vm.parent.$refs[vm.parent._uid + '{this.root}item-8'][0]._uid + 'notDefineditem-1'`]],
                    'datasource': {
                      options: [],
                      label: 'name',
                      value: 'id'
                    },
                    readonly: true
                  },
                  {
                    'field': 'detail',
                    'name': 'detail',
                    'type': 'TextArea',
                    'align': 'center',
                    'label': 'Chi tiểt',
                    'showInTable': false,
                    readonly: true
                  },
                  {
                    'field': 'unitPrice',
                    'name': 'unitPrice',
                    'type': 'NumberField',
                    'align': 'center',
                    'validation': 'required|decimal|min_value:0',
                    'label': 'Đơn giá',
                    readonly: true
                  },
                  {
                    'field': 'unit',
                    'name': 'unit',
                    'fieldName': 'notDefined',
                    'type': 'ComputedField',
                    'label': 'Đơn vị tính',
                    'align': 'center',
                    'func': '(this.rootModel.unitMoney ? this.rootModel.unitMoney : \'NA\') + \'/\' + (this.parent.value.unit ? this.parent.value.unit : \'NA\')',
                    'watch': true,
                    'show': true,
                    'showOnly': true,
                    '@tableOnly': {
                      'showFormat': '(this.rootModel.unitMoney ? this.rootModel.unitMoney : \'NA\') + \'/\' + (props.row.unit ? props.row.unit : \'NA\')'
                    }
                  },
                  {
                    'field': 'quantity',
                    'name': 'quantity',
                    'type': 'NumberField',
                    'align': 'center',
                    'validation': 'required|decimal|min_value:0',
                    'label': 'Số lượng',
                    readonly: true
                  },
                  {
                    // Show only in dialog
                    'field': 'moneyShow',
                    'name': 'moneyShow',
                    'fieldName': '{this.root}',
                    'type': 'Label',
                    'align': 'center',
                    'label': 'Thành tiền',
                    'format': '!isNaN(this.modelProps.unitPrice * this.modelProps.quantity) ? this.NumberUtils.thousandSeprator(this.modelProps.unitPrice * this.modelProps.quantity) : \'0\'',
                    'watch': true,
                    'showInTable': false
                  },
                  {
                    'field': 'money',
                    'name': 'money',
                    'fieldName': 'money',
                    'type': 'ComputedField',
                    'label': 'Thành tiền',
                    'align': 'center',
                    'func': '!isNaN(this.parent.value.unitPrice * this.parent.value.quantity) ? this.parent.value.unitPrice * this.parent.value.quantity : undefined',
                    'watch': true,
                    '@tableOnly': {
                      'showFormat': 'this.NumberUtils.thousandSeprator(props.row.money)'
                    }
                  },
                  {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    show: false,
                    css: [`col-12 col-sm-6 q-pr-xs`, `col-12 col-sm-5`, `col-1 col-sm-1 relative-position`],
                    colBody: []
                  }
                ],
                subribers: [[`vm.parent._uid + 'productLogisticsitem-2'`, `'bottomRow-totalMoney-3'`]],
                bottomRow: [
                  null, null, null, {
                  'fieldName': 'totalMoney',
                  'type': 'ComputedField',
                  'func': 'this.rootModel && this.rootModel && this.rootModel.productLogistics ? this.NumberUtils.thousandSeprator(this.math.sum(this.rootModel.productLogistics.map(x => x.money))) : \'0\'',
                  'watch': true
                }, 
                {
                  type: 'Label',
                  value: 'Tổng tiền',
                  fieldName: 'totalMoneyLabel',
                  align: 'right',
                  class: 'text-h6'
                },
                {
                  type: 'Label',
                  fieldName: 'totalMoney',
                  watch: true,
                  class: 'text-subtitle1',
                  align: 'center'
                }]
              },
              'item-3': {
                label: 'Ghi chú',
                type: 'TextArea',
                fieldName: 'deliveryNote',
                icon: 'speaker_notes',
                readonly: true,
                class: !this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''
              }
            }
          },
          'item-5': {
            type: 'Collapse',
            label: 'Thanh toán',
            icon: 'payment',
            fieldName: '{this.root}',
            centerText: {
              value: 'this.modelProps.hasOwnProperty(\'paymentStatus\') ? this.modelProps.paymentStatus.name : \'\'',
              useChip: true,
              color: 'this.modelProps.hasOwnProperty(\'paymentStatus\') ? this.modelProps.paymentStatus.color : \'\''
            },
            items: {
              'item-1': {
                label: 'Thanh toán',
                bordered: true,
                'indexColumn': true,
                'dataType': 'SingleArray',
                'editable': false,
                'canCreate': false,
                'canDelete': false,
                'inputKey': 1,
                'type': 'DataTable',
                'flat': true,
                'hideBottom': true,
                'pagination': {
                  'rowsPerPage': 0,
                  'descending': true
                },
                'fieldName': 'payments',
                'addType': 'last',
                'duplicateRules': {
                  'uniqueField': 'paymentDate'
                },
                'columns': [
                  {
                    label: 'Ngày thanh toán',
                    fieldName: 'paymentDate',
                    field: 'paymentDate',
                    name: 'paymentDate',
                    type: 'DatePicker',
                    validation: 'required',
                    readonly: true
                  },
                  {
                    'field': 'foreignCurrency',
                    'name': 'foreignCurrency',
                    'type': 'NumberField',
                    'align': 'center',
                    'label': 'Số tiền ngoại tệ',
                    validation: 'required|decimal|min_value:0',
                    readonly: true
                  },
                  {
                    'field': 'vndCurrency',
                    'name': 'vndCurrency',
                    'type': 'NumberField',
                    'align': 'center',
                    'label': 'Số tiền VND',
                    validation: 'required|decimal|min_value:0',
                    readonly: true
                  },
                  {
                    'field': 'note',
                    'name': 'note',
                    'type': 'TextArea',
                    'label': 'Ghi chú'
                  }
                ]
              },
              'item-2': {
                label: 'Sản phẩm theo hóa đơn',
                'indexColumn': true,
                'dataType': 'SingleArray',
                'editable': false,
                'canDelete': false,
                'inputKey': 1,
                'type': 'DataTable',
                bordered: true,
                'hideBottom': true,
                'pagination': {
                  'rowsPerPage': 0,
                  'descending': true
                },
                'fieldName': 'productAcct',
                'addType': 'last',
                'flat': true,
                'columns': [
                  {
                    'label': 'Sản phẩm',
                    'field': 'name',
                    'fieldName': '{this.root}',
                    '@tableOnly': {
                      'showFormat': 'props.row.name.concat(props.row.detail || props.row.hasOwnProperty(\'detail\') ? \' (\' + props.row.detail + \')\' : \'\')'
                    },
                    'syncModel': true,
                    'name': 'name',
                    'align': 'left',
                    'type': 'Select',
                    'isMerge': true,
                    'useInput': true,
                    'validation': {
                      'required': true
                    },
                    subribers: [[`vm.parent._uid + 'notDefineditem-4'`], [`vm.parent._uid + '{this.root}item-8'`, `'2' + vm.parent.$refs[vm.parent._uid + '{this.root}item-8'][0]._uid + 'notDefineditem-1'`]],
                    'datasource': {
                      options: [],
                      label: 'name',
                      value: 'id'
                    },
                    readonly: true
                  },
                  {
                    'field': 'detail',
                    'name': 'detail',
                    'type': 'TextArea',
                    'align': 'center',
                    'label': 'Chi tiểt',
                    'showInTable': false,
                    readonly: true
                  },
                  {
                    'field': 'unitPrice',
                    'name': 'unitPrice',
                    'type': 'NumberField',
                    'align': 'center',
                    'validation': 'required|decimal|min_value:0',
                    'label': 'Đơn giá',
                    readonly: true
                  },
                  {
                    'field': 'unit',
                    'name': 'unit',
                    'fieldName': 'notDefined',
                    'type': 'ComputedField',
                    'label': 'Đơn vị tính',
                    'align': 'center',
                    'func': '(this.rootModel.unitMoney ? this.rootModel.unitMoney : \'NA\') + \'/\' + (this.parent.value.unit ? this.parent.value.unit : \'NA\')',
                    'watch': true,
                    'show': true,
                    'showOnly': true,
                    '@tableOnly': {
                      'showFormat': '(this.rootModel.unitMoney ? this.rootModel.unitMoney : \'NA\') + \'/\' + (props.row.unit ? props.row.unit : \'NA\')'
                    }
                  },
                  {
                    'field': 'quantity',
                    'name': 'quantity',
                    'type': 'NumberField',
                    'align': 'center',
                    'validation': 'required|decimal|min_value:0',
                    'label': 'Số lượng',
                    readonly: true
                  },
                  {
                    // Show only in dialog
                    'field': 'moneyShow',
                    'name': 'moneyShow',
                    'fieldName': '{this.root}',
                    'type': 'Label',
                    'align': 'center',
                    'label': 'Thành tiền',
                    'format': '!isNaN(this.modelProps.unitPrice * this.modelProps.quantity) ? this.NumberUtils.thousandSeprator(this.modelProps.unitPrice * this.modelProps.quantity) : \'0\'',
                    'watch': true,
                    'showInTable': false
                  },
                  {
                    'field': 'money',
                    'name': 'money',
                    'fieldName': 'money',
                    'type': 'ComputedField',
                    'label': 'Thành tiền',
                    'align': 'center',
                    'func': '!isNaN(this.parent.value.unitPrice * this.parent.value.quantity) ? this.parent.value.unitPrice * this.parent.value.quantity : undefined',
                    'watch': true,
                    '@tableOnly': {
                      'showFormat': 'this.NumberUtils.thousandSeprator(props.row.money)'
                    }
                  },
                  {
                    type: 'Collumns',
                    fieldName: '{this.root}',
                    leftRightMode: true,
                    show: false,
                    css: [`col-12 col-sm-6 q-pr-xs`, `col-12 col-sm-5`, `col-1 col-sm-1 relative-position`],
                    colBody: []
                  }
                ],
                subribers: [[`vm.parent._uid + 'productAcctitem-2'`, `'bottomRow-totalMoney-3'`]],
                bottomRow: [
                  null, null, null, {
                  'fieldName': 'totalMoney',
                  'type': 'ComputedField',
                  'func': 'this.rootModel && this.rootModel && this.rootModel.productAcct ? this.NumberUtils.thousandSeprator(this.math.sum(this.rootModel.productAcct.map(x => x.money))) : \'0\'',
                  'watch': true
                }, 
                {
                  type: 'Label',
                  value: 'Tổng tiền',
                  fieldName: 'totalMoneyLabel',
                  align: 'right',
                  class: 'text-h6'
                },
                {
                  type: 'Label',
                  fieldName: 'totalMoney',
                  watch: true,
                  class: 'text-subtitle1',
                  align: 'center'
                }]
              },
              'item-3': {
                label: 'Ghi chú',
                type: 'TextArea',
                fieldName: 'paymentNote',
                icon: 'speaker_notes',
                readonly: true,
                class: !this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''
              }
            }
          },
          'item-6': {
            type: 'Collapse',
            label: 'Chi phí',
            icon: 'monetization_on',
            fieldName: '{this.root}',
            items: {
              'item-1': {
                'indexColumn': true,
                'dataType': 'SingleArray',
                'editable': false,
                'inputKey': 1,
                'type': 'DataTable',
                'flat': true,
                bordered: true,
                'hideBottom': true,
                'pagination': {
                  'rowsPerPage': 0,
                  'descending': true
                },
                'fieldName': 'costs',
                'addType': 'last',
                'columns': [
                  {
                    label: 'Ngày',
                    field: 'date',
                    name: 'date',
                    type: 'DatePicker',
                    validation: 'required'
                  },
                  {
                    'field': 'costType',
                    'name': 'costType',
                    'type': 'Select',
                    'align': 'center',
                    'label': 'Loại chi phí',
                    '@tableOnly': {
                      'showFormat': 'props.row.costType.name'
                    },
                    'datasource': {
                      options: [],
                      field: 'list',
                      label: 'name',
                      value: 'id'
                    },
                    sortBy: 'name',
                    validation: 'required'
                  },
                  {
                    'field': 'money',
                    'name': 'money',
                    'type': 'NumberField',
                    'align': 'center',
                    'label': 'Số tiền',
                    validation: 'required|decimal|min_value:0'
                  },
                  {
                    'field': 'costInvoice',
                    'name': 'costInvoice',
                    'type': 'TextField',
                    'align': 'center',
                    'label': 'Mã hoá đơn'
                  },
                  {
                    'field': 'note',
                    'name': 'note',
                    'type': 'TextArea',
                    'label': 'Ghi chú'
                  }
                ]
              },

              'item-2': {
                label: 'Ghi chú',
                type: 'TextArea',
                fieldName: 'costNote',
                icon: 'speaker_notes',
                readonly: true,
                class: !this.$q.screen.xs ? 'q-pl-md q-pr-md' : ''
              }

            }
          }
        }
      },
      isLoading: true,
      isSubmiting: false,
      canSubmit: false,
      backLink: {
        path: '/manage-order',
      },
      queryPath: ['Orders', this.orderId ? this.orderId : this.$route.query.id ? this.$route.query.id : null],
      baseData: null
    }
  },
  async mounted () {
    if (this.hasPerm()) {
      await this.auth()
      this.queryNamisOrder()
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'namisInfo'
    ]),
  },
  methods: {
    async auth() {
      if (!this.namisInfo) {
        let info = await this.$query(['Users','namis'])
        if (!info.tokenId) {
          await axios.post(`https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${info.apiKey}`,{
            email: info.email,
            password:info.password,
            returnSecureToken: true
          }).then(res => {
            let innerInfo = info
            innerInfo.idToken = res.data.idToken
            this.$store.dispatch('registerNamisInfo',innerInfo)
          })
        } else this.$store.dispatch('registerNamisInfo',innerInfo)
        
      } 
    },
    async queryNamisOrder() {
      if (this.namisInfo) {
        await axios({
          url :`https://firestore.googleapis.com/v1/projects/${this.namisInfo.projectId}/databases/(default)/documents/Orders/${this.orderId}`,
          method: 'get',
          headers: {
            'Content-Type':'application/json',
            'Authorization': `Bearer ${this.namisInfo.idToken}`
          }
        }).then(res => {
          let data = this.parseData(res.data.fields)
          let innerParse = this.parseData(data.metaData)
          data.lastModifiedBy = data.metaData.lastModifiedBy
          data.lastModifiedTime = data.metaData.lastModifiedTime
          this.baseData = data
        })
      }
    },
    parseData(data) {
      return TimestampUtils.timestampParser(FireStoreParser(data), schemas.TYPE)
    },
    hasPerm() {
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      let roles = this._.intersection(accept, Object.keys(this.permission.roles))
      return roles.length > 0
    },
    async handlerSubmit (payload, resolve, reject) {
      let vm = this
      let submitModel = { id: payload.id, data: payload.data }
      await vm.$command.execute('updateOrder', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
    actionAclEdit () {
      // this.scaffolding.items['item-3'].items['item-2'].editable = this.mode === 'EDIT' || this.orderId ? this.canEdit : this.canCreate
      this.scaffolding.items['item-3'].items['item-2'].editable = true
    },
    async fetchProduct (data) {
      let vm = this
      await vm.$query(['MasterData', 'Product']).then(res => {
        if (!res.error) {
          let listProduct = this.productFilterCondition(res, data)
          vm.scaffolding.items['item-3'].items['item-2'].columns[0].datasource.options = listProduct.sort((a, b) => a.name.localeCompare(b.name))
          // vm.scaffolding.items['item-4'].items['item-2'].columns[0].datasource.options = listProduct.sort((a, b) => a.name.localeCompare(b.name))
          // vm.scaffolding.items['item-5'].items['item-2'].columns[0].datasource.options = listProduct.sort((a, b) => a.name.localeCompare(b.name))
        }
      }).catch(e => console.log(e))
    },
    productFilterCondition (res, data) {
      return res.list ? res.list.filter(x => x.saleDep === 'TB') : []
    },
    async fetchMfgStatus () {
      let vm = this
      await vm.$query(['MasterData', 'MfgStatus']).then(res => {
        if (!res.error) {
          let options = res ? vm._.values(vm._.mapKeys(res, (value, key) => { value.id = key; return key })) : []
          vm.scaffolding.items['item-3'].items['item-2'].columns[8].datasource.options = options.filter(item => item.id != 'metaData')
        }
      }).catch(e => { throw new Error(e) })
    },
    async fetchCosts () {
      let vm = this
      await vm.$query(['MasterData', 'Costs']).then(res => {
        if (!res.error) {
          vm.scaffolding.items['item-6'].items['item-1'].columns[1].datasource.options = res.list ? res.list.filter(i => !i['@deleted']) : []
        }
      }).catch(e => console.log(e))
    },
    async fetchPorts () {
    },
    async processOrderStatus (data) {
      let vm = this
      vm.scaffolding.items['item-1'].colBody[1]['item-1'].isLoading = true
      vm.scaffolding.items['item-1'].colBody[1]['item-1'].inputKey++
      await vm.$query(['MasterData', 'OrderStatus']).then(res => {
        const convertedStatus = vm._.mapKeys(res, (value, key) => { value.id = key; return key })
        let tempRes = vm._.values(convertedStatus)
        const filteredDraftStatus = tempRes.filter(i => i.id === 'draft')
        if (vm.mode === 'CREATE' || !vm.orderId) {
          let next = filteredDraftStatus[0].next
          vm.scaffolding.items['item-1'].colBody[1]['item-1'].datasource.options = vm._.values(vm._.pick(convertedStatus, next))
          data.orderStatus = filteredDraftStatus[0]
        } else if (vm.mode === 'EDIT' || vm.orderId) {
          let next = data.hasOwnProperty('orderStatus') ? data.orderStatus.next : []
          let picked = vm._.values(vm._.pick(convertedStatus, next))
          vm.scaffolding.items['item-1'].colBody[1]['item-1'].datasource.options = picked
        }
      }).catch(e => console.log(e))
      vm.scaffolding.items['item-1'].colBody[1]['item-1'].isLoading = false
      vm.scaffolding.items['item-1'].colBody[1]['item-1'].inputKey++
    },
    detailPageFetched (data) {
      this.processOrderStatus(data)
      this.fetchProduct(data)
    }
  }
}
</script>
